export const ADD_ITEM = "ADD_ITEM";
export const REMOVE_ITEM = "REMOVE_ITEM";
export const SET_GOOGLE_PLACE_ITEM = "SET_GOOGLE_PLACE_ITEM";
export const CHANGE_TAB = "CHANGE_TAB";
export const CHANGE_MAP = "CHANGE_MAP";
export const SAVE_CLUSTERS = "SAVE_CLUSTERS";
export const SET_RESULTS = "SET_RESULTS";
export const SHOW_RESULTS = "SHOW_RESULTS";
export const SET_DETAIL = "SET_DETAIL";
export const GET_ALERTS = "GET_ALERTS";
export const SHOW_DETAIL = "SHOW_DETAIL";
export const SET_HOVER = "SET_HOVER";
export const TOGGLE_MENU = "TOGGLE_MENU";
export const TOGGLE_HELP = "TOGGLE_HELP";
export const SET_WINDOW_SIZE = "SET_WINDOW_SIZE";
export const SHOW_INFO = "SHOW_INFO";
export const SLIDE_CAROUSEL = "SLIDE_CAROUSEL";
export const SEARCH_IN_PROGRESS = "SEARCH_IN_PROGRESS";
export const EXPAND_MAP = "EXPAND_MAP";
export const PREPARE_DATA = "PREPARE_DATA";
export const SHOW_GLOBAL_ALERT = "SHOW_GLOBAL_ALERT";
export const USER_CLOSED_NS_MESSAGE = "USER_CLOSED_NS_MESSAGE";
export const SAVE_MAP = "SAVE_MAP";
export const SAVE_MAPS = "SAVE_MAPS";
export const RECENTER_MAP = "RECENTER_MAP";
export const FETCH_NEWS = "FETCH_NEWS";
export const FETCH_ADS = "FETCH_ADS";
export const FETCH_GRADES = "FETCH_GRADES";
export const CLICK_AD = "CLICK_AD";
export const SEARCHED = "SEARCHED";
export const SORT_RESULTS = "SORT_RESULTS";



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js